<script setup lang="ts">
import { useUserInfoStore } from '@/stores/modules/user'

const userStore = useUserInfoStore()
</script>
<template>
  <div class="logo">
    <el-icon :size="32" color="#0473fb">
      <ElementPlus />
    </el-icon>
    <span v-if="!userStore.collapse" class="font-bold text-black text-nowrap">大华测控</span>
  </div>
</template>
<style scoped lang="scss">
.logo {
  @apply flex justify-center items-center space-x-4 py-4;
}
</style>
